export const normalizeZip = (value) => {
    const match = String(value || '').match(/\b\d{5}\b/);
    return match ? match[0] : '';
};

export const parseCityState = (cityRegion) => {
    const value = String(cityRegion || '').trim();
    const [city = '', state = ''] = value.split(',').map(part => part.trim());

    return { city, state };
};

/**
 * Fetch coordinates from the backend geocode endpoint.
 * The backend uses the `zipcodes` npm package to resolve any US zip or city/state.
 * Returns { city, state, latitude, longitude } or null.
 */
export const fetchCoordinatesForLocation = async (query) => {
    if (!query) return null;

    try {
        const response = await fetch(`/api/geocode?q=${encodeURIComponent(query)}`);
        if (!response.ok) return null;

        const data = await response.json();
        return data || null;
    } catch {
        return null;
    }
};

// Best-effort approximate location from the visitor's IP, used to default the
// Browse filters to their area. Returns null on any failure so callers fall
// back to the nationwide view.
export const fetchApproximateLocation = async () => {
    try {
        const response = await fetch('/api/geo/ip');
        if (!response.ok) return null;

        const data = await response.json();
        return data || null;
    } catch {
        return null;
    }
};


export const getDistanceMiles = (origin, destination) => {
    if (!origin || !destination) {
        return null;
    }

    const originLatitude = Number(origin.latitude);
    const originLongitude = Number(origin.longitude);
    const destinationLatitude = Number(destination.latitude);
    const destinationLongitude = Number(destination.longitude);

    if (![originLatitude, originLongitude, destinationLatitude, destinationLongitude].every(Number.isFinite)) {
        return null;
    }

    const degreesToRadians = degrees => degrees * (Math.PI / 180);
    const earthRadiusMiles = 3958.8;
    const latitudeDistance = degreesToRadians(destinationLatitude - originLatitude);
    const longitudeDistance = degreesToRadians(destinationLongitude - originLongitude);
    const a = Math.sin(latitudeDistance / 2) ** 2
        + Math.cos(degreesToRadians(originLatitude))
        * Math.cos(degreesToRadians(destinationLatitude))
        * Math.sin(longitudeDistance / 2) ** 2;

    return 2 * earthRadiusMiles * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};
